<template>
  <el-dialog
    title="视频播放"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose">
    <div class="videoArea">
        <video width="100%" height="100%" controls :src="videoUrl"></video>
    </div>
  </el-dialog>
  
</template>

<script>
export default {
name: 'videoPlay',
props: {
  // 接收父组件传递的参数
  visible: {
    type: Boolean,
    default: false
  },
  videoUrl: {
    type: String,
    default: ''
  }
},
data() {
  return {

  }
},
computed: {
  // 计算属性
  dialogVisible: {
    get() {
      return this.visible
    },
    set(val) {
      this.$emit('update:visible', val)
    }
  }
},
methods: {
  handleClose() {
    this.dialogVisible = false
  }
}
}
</script>

<style lang="scss" scoped>
.videoArea {
width: 100%;
height: 400px;
}
</style>